/**
 * brand(品牌信息) Brand Controller
 */
import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const brand = {
  // DELETE/brand/remove/{id}删除
  brandRemove(id) {
    return axios.delete(`${base.baseURL}brand/remove/${id}`)
  },
  // POST/brand/save/{name}PC---新增品牌---ygt
  brandSave(name) {
    return axios.post(`${base.baseURL}brand/save/${name}`)
  },
}
export default brand;



// WEBPACK FOOTER //
// ./src/network/brand.js